import { useEffect, useState } from 'react'

import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { ConsoleTextField } from '@/components/inputs/StyledInputComponents'

import { CASES_LABEL_MAP, GENERIC_INPUT_PLACEHOLDER } from './constants'

type Props = {
  checked?: boolean
  attribute: string
  value: string
  onChange: (value: { duration: string }) => void
  onCheckboxChange: (checked: boolean) => void
}

export const CaseCheckbox = ({ checked, attribute, value, onChange, onCheckboxChange }: Props) => {
  const [isChecked, setIsChecked] = useState(checked || false)

  useEffect(() => {
    if (checked === undefined) return

    setIsChecked(checked)
  }, [checked])

  const handleCheckboxChange = (checked: boolean) => {
    setIsChecked(checked)
    onCheckboxChange(checked)

    if (!checked) {
      onChange({ duration: '' })
    }
  }

  return (
    <Grid size={4}>
      <FormControlLabel
        control={
          <Checkbox checked={isChecked} onChange={(e) => handleCheckboxChange(e.target.checked)} />
        }
        label={
          <Typography>{CASES_LABEL_MAP[attribute as keyof typeof CASES_LABEL_MAP]}</Typography>
        }
      />

      <ConsoleTextField
        placeholder={GENERIC_INPUT_PLACEHOLDER}
        name={attribute}
        value={value}
        fullWidth
        disabled={!isChecked}
        onChange={(e) => onChange({ duration: e.target.value })}
      />
    </Grid>
  )
}
